<!-- =========================================================================================
  File Name: ItemGridView.vue
  Description: Item Component - Grid VIew
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <!-- <div class="item-grid-view vx-row match-height">
        <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
  <vx-card class="grid-view-item mb-base overflow-hidden" v-on="$listeners">
    <template slot="no-body">
      <vx-tooltip
        :text="
          item.hasOwnProperty('status_published')
            ? item.status_published
              ? 'Published'
              : 'Unpublished'
            : 'Published'
        "
        position="bottom"
        delay=".3s"
        class="m-2 h-4 w-4 right-0 status-dot"
      >
        <div
          class="h-4 w-4 rounded-full"
          :class="{
            'gray-color': item.hasOwnProperty('status_published')
              ? item.status_published == false
              : false,
            'purple-color': item.hasOwnProperty('status_published')
              ? item.status_published
              : true,
          }"
        />
      </vx-tooltip>
      <!-- ITEM IMAGE -->
      <div
        class="item-img-container bg-white h-64 flex items-center justify-center mb-4 cursor-pointer"
        @click="navigate_to_detail_view"
      >
        <img
          v-if="item.video_url"
          :src="getYouTubeThumbnail(item.video_url)"
          :alt="item.category"
          class="grid-view-img"
        />
        <img
          v-else
          src="@/assets/images/logo/DHP Logo no text.png"
          class="grid-view-img"
        />
      </div>
      <div class="item-details px-4">
        <!-- RATING & PRICE -->
        <div class="flex justify-between items-center">
          <!-- <div class="text-warning border border-solid border-warning flex py-1 px-2 rounded">
                                <span class="text-sm mr-1">{{ item.rating }}</span>
                                <feather-icon icon="StarIcon" svgClasses="h-4 w-4" />
                            </div> -->
          <!-- <h6 class="font-bold">${{ item.price }}</h6> -->
        </div>

        <!-- TITLE & DESCRIPTION -->
        <div class="my-4">
          <h6
            class="truncate font-semibold mb-1 hover:text-primary cursor-pointer"
            @click="navigate_to_detail_view"
          >
            {{ item.category }}
          </h6>
          <p class="item-description truncate text-sm">
            {{ item.video_title }}
          </p>
        </div>
      </div>

      <!-- SLOT: ACTION BUTTONS -->
      <slot name="action-buttons" />
    </template>
  </vx-card>
  <!--  </div>
    </div> -->
</template>

<script>
import DataProvider from "../../../../services/data-provider";
import Constant from "../../../../services/constant";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    navigate_to_detail_view() {
      this.$router
        .push({
          name: "health-hacks-item-detail-view",
          params: { category: this.item.category, item_id: this.item.id },
        })
        .catch(() => {});
    },
    getYouTubeThumbnail(url) {
      const id = DataProvider.getYouTubeId(url);
      // console.log(id);
      return Constant.you_tube_thumbnail_url + id + Constant.image_type;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-view-item {
  .purple-color {
    // background-color: #7367f0;
    background-color: green;
  }
  .gray-color {
    background-color: #e2e2e2;
  }
  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
    padding: 16px;
    padding-top: 25px;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
  h6.truncate {
    text-transform: capitalize;
  }
}
</style>
